<template>
  <div class="col-sm-12">
    <br />
    <br />
    <h3>Changing Usernames or Passwords</h3>
    <div>
      <div>
        <div>
          <span><h4>Changing Passwords</h4></span>
        </div>
        <div>
          <span>
            <p class="NOTE">
              At times it may be advisable to change all or some of your user's passwords. It's easy to do, but there are a few simple rules to
              follow.
            </p>
            <ul>
              <li>
                You must submit the <em>Current</em> username and password and the correct location (company_name or company_id) for the user you are
                trying to update. The application uses the username, password and location to identify the user before altering the password.
              </li>
              <li>
                The new password goes in the <a class="text" href="index.cfm?action=admin.helpHandler&amp;help=column">New_password</a>
                field.
              </li>
              <li>The new password must be at least 5 characters long.</li>
              <li>The new password should <em>NOT</em> contain a space</li>
              <li>
                The new password cannot be the same as the username and should never be something obvious (like the word "password" or the users first
                or last name).
              </li>
            </ul>
            As long as you follow these simple rules, it's pretty easy to update the users password.
            <p></p>

            <br />
          </span>
        </div>

        <div>
          <span><h4>Changing UserNames</h4></span>
        </div>
        <div>
          <span>
            <p class="NOTE">
              At times it may be necessary to change a username. For example if you use a convention like first initial last name (i.e Mike Johson
              would be MJohnson), and someone changes a last name (as often happens through marraige), you may need to update that users username.
              It's easy to do, but you should follow a couple of simple rules.
            </p>
            <ul>
              <li>
                You must submit the <em>Current</em> username and password and the correct location (company_name or company_id) for the user you are
                trying to update. The application uses the username, password and location to identify the user before altering the password.
              </li>
              <li>
                Put the new username in the <a class="text" href="index.cfm?action=admin.helpHandler&amp;help=column">New_username</a>
                field.
              </li>
              <li>Do not allow spaces or strange characters (like astericks) in usernames</li>
            </ul>
            As long as you follow these simple rules, it's pretty easy to update a username.
            <p></p>

            <br />
          </span>
        </div>
      </div>
    </div>
    <br />
    <br />
  </div>
</template>
<script>
export default {
  name: 'ChangePassword',
};
</script>
<style scoped>
h3 {
  text-align: center;
}
table {
  border: 0px solid transparent;
  font-size: 14px;
  width: inherit;
}
fieldset {
  padding: 0.35em 0.625em 0.75em;
  margin: 0 5px;
  border: 1px solid silver;
  border-radius: 8px;
}
legend {
  width: auto;
  padding: 10px;
  font-size: 15px;
  color: #333;
  border: 0;
  border-bottom: none;
}
</style>
